<template>
    <div>
        <b-breadcrumb class="px-4 bg-light pb-0" :items="breadcrumbs" />
        <div class="page-content">
            <div
                class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mt-4 mb-3"
            >
                <div class="title">
                    <h1 class="mb-0">Global Notification Settings</h1>
                </div>
                <div>
                    <div v-if="isSaving" class="updated">Saving...</div>
                    <div v-else-if="lastUpdatedDurationText" class="updated">
                        Last updated {{ lastUpdatedDurationText }} ago
                    </div>
                </div>
            </div>
            <b-card footer-class="p-0" class="side-tab">
                <div v-if="isLoading">
                    <LoaderList />
                </div>
                <div v-else>
                    <div
                        v-for="globalNotiSetting in globalNotiSettings"
                        :key="globalNotiSetting.module"
                        class=""
                    >
                        <div>
                            <h3>{{ globalNotiSetting.title }}</h3>
                            <p class="module-label">
                                {{ globalNotiSetting.description }}
                            </p>
                        </div>
                        <div>
                            <div
                                v-for="setting in globalNotiSetting.settings"
                                :key="setting.type"
                                class="green-toggle custom-control custom-switch py-1"
                            >
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    :id="setting.type"
                                    v-model="
                                        setting.data[0].notification_to_task
                                    "
                                    @change="updateSetting(setting)"
                                />
                                <label
                                    class="custom-control-label"
                                    :for="setting.type"
                                >
                                    {{ setting.label }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import LoaderList from "@/components/elements/loader-list";
import NotificationService from "@/services/setting/notification";
import SettingMixin from "@/mixins/settings";
import { sortBy } from "lodash";

export default {
    mixins: [SettingMixin],
    components: { LoaderList },
    data() {
        return {
            isLoading: true,
            isSaving: false,
            globalNotiSettings: []
        };
    },
    computed: {
        breadcrumbs() {
            return [
                {
                    text: "Settings",
                    href: process.env.APPS + "business/business"
                },
                {
                    text: "Global Notification Settings"
                }
            ];
        }
    },
    created() {
        this.firstLoad();
    },
    methods: {
        async firstLoad() {
            await this.getTaskGlobalNotiSettings();
            this.isLoading = false;
        },
        async getTaskGlobalNotiSettings() {
            const response =
                await NotificationService.getTaskGlobalNotiSettings();

            if (
                response &&
                response.code &&
                response.code == 200 &&
                response.resource &&
                response.resource.settings
            ) {
                this.globalNotiSettings.push({
                    module: "task",
                    title: "Automatic Task Conversion",
                    description:
                        "Automatically convert notifications within the selected types to a task. By default, the task will be assigned to the provider associated with the record.",
                    settings: sortBy(response.resource.settings, ["type"])
                });

                if (response.resource.updated_at) {
                    this.setIntervalAndTimeoutUpdatedDuration(
                        response.resource.updated_at
                    );
                }
            }
        },
        async updateSetting(setting) {
            this.isSaving = true;
            const { type, data } = setting;

            if (type && data && data[0]) {
                const response =
                    await NotificationService.updateGlobalNotiSettings({
                        type,
                        settings: {
                            notification_to_task: data[0].notification_to_task
                        }
                    });

                if (response && response.code && response.code == 200) {
                    this.setIntervalAndTimeoutUpdatedDuration();
                }
            }

            this.isSaving = false;
        }
    }
};
</script>

<style scoped>
.module-label {
    max-width: 600px;
}
.card-body {
    min-height: 500px;
}
</style>
